// Name of the "managed" folder in a drive that is used for various features.
export const DRIVE_MANAGED_FOLDER_NAME = 'Nano';
